import { date, identifier, object, primitive, serializable } from 'serializr';
import { SynchronizableData } from 'stores/Persistable';
import { EditableRessource } from './EditableRessource';

export default class Equipment implements EditableRessource {
  @serializable(identifier())
  id?: number;
  @serializable(primitive())
  name?: string;
  @serializable(primitive())
  deactivatable: boolean = true;
  @serializable(primitive())
  updatable: boolean = true;
  @serializable(primitive())
  deletable: boolean = true;
  @serializable(primitive())
  enabled: boolean = true;

  get Id() {
    if (this.id === undefined) {
      throw new Error('Undefined field "id"');
    }
    return this.id;
  }
}

export class EquipmentSynchronizableData implements SynchronizableData<Equipment> {
  constructor(isSynchronized: boolean, data: Equipment) {
    this.isSynchronized = isSynchronized;
    this.data = data;
    if (isSynchronized) {
      this.lastSynchronizedOn = new Date();
    }
  }

  @serializable
  isSynchronized: boolean;

  @serializable(date())
  lastSynchronizedOn?: Date;

  @serializable(date())
  storedAt?: Date;

  @serializable(object(Equipment))
  data: Equipment;
}
